import React from 'react';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-3">
          Reset de los 30+: Recupera tu ambición de conquista en{' '}
          <span className="text-yellow-500" data-id="element-4">72 horas</span>
        </h2>

        <div className="space-y-4" data-id="element-5">
          {["Eliminarás el 'Síndrome del Inmigrante Eterno' que te mantiene pequeño.", 'Aprenderás a negociar salario y precios sin que te tiemble la voz.', 'Instalarás el sistema de creencias de los top 1% earners en USA.', 'Dejarás de pedir permiso para tener éxito.', 'Recuperarás la energía y el hambre que tenías a los 20 años, pero con la experiencia de hoy.'].map((benefit, index) => <div key={index} className="flex items-start gap-4 bg-slate-800/30 p-4 rounded-xl border border-slate-700/50" data-id="element-6">
              <div className="bg-green-500/20 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-7">
                <Check className="w-5 h-5 text-green-500" data-id="element-8" />
              </div>
              <p className="text-lg text-slate-200 font-medium" data-id="element-9">{benefit}</p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-10">
          <p className="text-slate-400 text-lg mb-2" data-id="element-11">
            ¿Cuánto te cuesta seguir operando con el software viejo?
          </p>
          <p className="text-red-400 font-bold" data-id="element-12">
            Cada mes que pasas dudando, dejas miles de dólares sobre la mesa.
          </p>
        </div>
      </div>
    </section>;
}